import React from 'react';

const Vue_Provide_Inject = () => {
  return (
    <div>
      <h1>Vue_Provide_Inject Component</h1>
      <p>This is the Vue_Provide_Inject tutorial page.</p>
    </div>
  );
}

export default Vue_Provide_Inject;
